<dt ng-if="object.descricao.length > 25" uib-tooltip="{{object.descricao | capitalize}}" tooltip-append-to-body="true">
  {{object.descricao | capitalize | characters:25}}:
</dt>
<dt ng-if="object.descricao.length <= 25">
  {{object.descricao | capitalize}}:
</dt>
<dd>
  <dl class="no-margin" ng-repeat="texto in object.summarize">
    <dt>{{texto.situacao_to_pt_br}}:</dt>
    <dd>
      <ng-pluralize count="texto.quantidade_pontos"
        when="{'0': 'Nenhum ponto',
               'one': '1 ponto',
               'other': '{{texto.quantidade_pontos}} pontos'}">
      </ng-pluralize>
    </dd>
  </dl>
</dd>
